import { FC } from 'react';

export const Grid: FC = ({ children }) => (
  <dl className='grid grid-cols-2 gap-x-4 gap-y-8'>
    { children }
  </dl>
);
